import { useRuntimeConfig } from '~/.nuxt/imports';

/** Mirrors `publicRuntimeConfig.features` in nuxt.config.js. */
export interface FeatureFlags {
  showLogin: boolean;
  showTickets: boolean;
  showSecondary: boolean;
  enableGoogleSSO: boolean;
  enableAppleSSO: boolean;
  enableFacebookSSO: boolean;
  mainOrganizer: string;
  showCrypto: boolean;
  enableOrganizers: boolean;
  requirePhoneVerification: boolean;
  showReportsDashboard: boolean;
  showNftCollectibles: boolean;
  featuredEvents: boolean;
  showOrganizerReportsDashboard: boolean;
  enableMetaTracking: boolean;
  metaPixelId: string;
  enableMatomo: boolean;
  pdfTemplates: boolean;
  showOrganizerOnboarding: boolean;
  showTicketInsurance: boolean;
}

/**
 * Reads the flags straight from runtime config rather than the per-flag `$show*`
 * injections in plugins/axios.ts — those are a copy of the same data, and any
 * hand-maintained mirror of them drifts out of date.
 */
export function useFeatureFlags(): FeatureFlags {
  return useRuntimeConfig().features;
}
